import { Title } from "@mantine/core";
import { L2KH3Props } from "./types";
import { H3_STYLE, COLORS } from "./constants";

/**
 * L2KH3 - Third level heading component
 * Renders as <h3> by default, uses Big Shoulders Display font
 * Responsive sizing: 28px → 36px across 320px → 1920px viewports
 */
export function L2KH3({
  children,
  variant = "primary",
  component = "h3",
  style,
  ...props
}: L2KH3Props) {
  return (
    <Title
      order={3}
      component={component}
      style={{
        fontSize: H3_STYLE.fontSize,
        lineHeight: H3_STYLE.lineHeight,
        letterSpacing: H3_STYLE.letterSpacing,
        fontWeight: H3_STYLE.fontWeight,
        fontFamily: H3_STYLE.fontFamily,
        margin: 0,
        color: COLORS[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
}
